<template>
  <div class="col-12 px-2">
    <div>
      <h1>{{ $t('wereOnOurWay') }}</h1>
    </div>
    <div>
      <h3>
        {{ $t('youHaveAlreadyNotified') }}
        <span v-If="locationPhone"> {{ $t('at') }} {{ locationPhone }}</span
        >.
      </h3>
    </div>
  </div>
</template>
<script>
import { getLocationPhone } from '@/utils';

export default {
  computed: {
    locationPhone() {
      return getLocationPhone(this.$configuration.store);
    },
  },
};
</script>
